import { render } from "./odn-config-button.vue?vue&type=template&id=46215fce"
import script from "./odn-config-button.vue?vue&type=script&lang=js"
export * from "./odn-config-button.vue?vue&type=script&lang=js"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__